import { call, put, takeEvery } from 'redux-saga/effects';
import { isEmpty, orderBy } from 'lodash';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* getDashboard({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.dashboard, signal });

    const preparedData = data.results.filter(item => item.is_visible === true && !isEmpty(item.content));

    
    yield put(actions.getDashboardDone(orderBy(preparedData, ['weight'])));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDashboardFailed,
      endpoint: api.dashboard.url
    });
  }
}

export const getDashboardSaga = takeEvery(types.GET_DASHBOARD_REQUEST, getDashboard);